<section class="section-calendar">
  <div class="container-calendar">
    <h3 class="input-title-blue">{{ "SelectDate" | translate }}</h3>
    <mat-calendar
      [(selected)]="calendarTime"
      class="calendar"
      (click)="SelectDateDinamic()"
      [dateFilter]="DateFilter"
    ></mat-calendar>
  </div>
  <div class="container-select-hour">
    <h3 class="input-title-blue">{{ "SelectHour" | translate }}</h3>
    <div class="Spinner" *ngIf="LoadingHours"><mat-spinner></mat-spinner></div>
    <div class="content-btn-hour" *ngIf="isDateSelected && !LoadingHours">
      <div
        class="btn-hour-for"
        *ngFor="let timehour of timeListButtons; let index = index"
      >
        <button
          mat-raised-button
          [ngClass]="timehour.class"
          class="btn-hour"
          (click)="timeValue(timehour, index)"
          name="timeButton"
        >
          {{ timehour.hours }}
        </button>
      </div>
    </div>
    <div
      class="message-container"
      *ngIf="timeListButtons.length === 0 && !LoadingHours && isDateSelected"
    >
      <i class="messageNoDate">{{ "NoHoursSelected" | translate }}</i>
    </div>
    <div
      class="message-container"
      *ngIf="timeListButtons.length === 0 && !LoadingHours && !isDateSelected"
    >
      <i class="messageNoDate">{{ "NoDateSelected" | translate }}</i>
    </div>
  </div>
</section>
